import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Select as AntSelect} from 'antd'
import request from '../../utils/request'

class Select extends Component {
    state = {
        data: null,
    };



    componentDidMount() {
        const {url, getData} = this.props
        if (this.props.url) {
            this.fetch(url, getData);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.url && nextProps.url !== this.props.url) {
            const {url, getData} = nextProps;
            this.fetch(url, getData);
        }
        const {defaultFirst, value, onChange, valueField} = nextProps;
        const {data} = this.state;
        if (defaultFirst && !value && onChange && data && data.length > 0) {
            onChange(data[0][valueField])
        }
    }


    fetch = (url, getData) => {
        request({
            url: url
        }).then(({data}) => {
            if (getData) {
                data = getData(data)
            }
            this.setState({
                data: data
            });
            const {defaultFirst, value, onChange, valueField} = this.props
            if (defaultFirst && !value && onChange && data.length > 0) {
                onChange(data[0][valueField])
            }
        })
    };

    render() {
        const {textField, valueField, children, ...restProps} = this.props;
        return (
            <AntSelect {...restProps}
            >
                {children}
                {this.state.data && this.state.data.map(item => {
                    return (
                        <AntSelect.Option key={item[valueField]}
                                          value={item[valueField]}>
                            {item[textField]}
                        </AntSelect.Option>
                    )
                })}
            </AntSelect>
        )
    }
}

Select.propTypes = {
    data: PropTypes.array,
    url: PropTypes.string,
    textField: PropTypes.string,
    valueField: PropTypes.string,
    getData: PropTypes.func,
    defaultFirst: PropTypes.bool
};

Select.defaultProps = {
    textField: 'id',
    valueField: 'text',
    defaultFirst: false
};

export default Select